import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import "../../Assets/scss/components/TwoFactorStatus.scss";
import { StoreProptypes } from "../../PropTypes/StoreProptypes";
import { useSelector, useDispatch } from "react-redux";
import { SET_MESSAGE } from "../../Actions/Types";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getUserDetailsApi } from "../../Api/UserAction/LoginActionApi";
import Disable2FAModal from "./Disable2FAModal";


const TwoFactorStatus: React.FC = () => {
  const { accessToken } = useSelector((store: StoreProptypes) => store);
  const dispatch = useDispatch();
  const [enable, setEnable] = useState<Number>();
  const { t } = useTranslation();
  const getUser = (): void => {
    if (accessToken) {
      getUserDetailsApi(accessToken)
        .then((res) => {
          if (res?.Data) {
            setEnable(res?.Data?.is_google2fa_enabled);
          }
        })
        .catch((err) => {
          dispatch({
            type: SET_MESSAGE,
            payload: {
              toast_message: `${err}`,
              toast_type: "danger",
            },
          });
        });
    }
  };

  useEffect(() => {
    getUser();
  }, [accessToken, dispatch, enable]);

  const navigate = useNavigate();
  const handleEnable = (): void => {
    if (enable === 0) {
      navigate("/front/enable-twofactor-authentication");
    }
  };
  const [showModal, setShowModal] = useState(false);

  const handleDisable2FA = (otp: string) => {
    setShowModal(false);
  };

  return (
    <>
      <div className="two-fa-status mt-2">
        <div className="two-fa-header">
          <h4 className="mb-0 h5">{enable === 0 ? t("Two-factor authentication") : t("Disable two-factor authentication")}</h4>
        </div>
        <div className="p-4">
          <p className="text-muted">
            {enable === 0
              ? t(
                  "Increase your account's security by enabling two-factor authentication (2FA)"
                )
              : t(
                  "Use this section to disable your one-time password authenticator and WebAuthn devices."
                )}
          </p>
          {enable === 0 ? (
            <Button variant="primary" onClick={handleEnable}>
              {t("Enable two-factor authentication")}
            </Button>
          ) : (
            <Button variant="danger" onClick={() => setShowModal(true)}>
              {t("Disable two-factor authentication")}
            </Button>
          )}
        </div>
      </div>
      <Disable2FAModal
        show={showModal}
        onHide={() => setShowModal(false)}
        onDisable={handleDisable2FA}
        user={getUser}
      />
    </>
  );
};

export default TwoFactorStatus;
